<template>
    <div><div id="subscriber"></div></div>
</template>

<script>
    import {mapState, mapActions, mapMutations} from 'vuex';
    import api from "../../../../../admin/api/api";
    import OT from '@opentok/client';

    export default {
        name: 'publisher',
        props: {
            opts: {
                type: Object,
                required: false,
            }
        },
        computed: {
            ...mapState('conference', [
                'session',
                'subscriber',
                'mediaAccess',
                'conferenceSetup'
            ]),
            ...mapState([
                'user',
                'consultation'
            ]),
        },
        mounted: function() {
            let publisher = OT.initPublisher(this.$el, this.opts);

            OT.getUserMedia().then(media => {
                api.post('/api/room-log', {type: "publisher", active: media.active, consultation: this.consultation});

                this.setMediaAccess(true);
            }).catch(error => {
                api.post('/api/room-log', {type: "publisher", data: error, consultation: this.consultation});

                this.setMediaAccess(false);
            });

            this.setPublisher(publisher);

            if (this.session && this.session.isConnected()) {
                this.publish();
            }

             if (this.session) {
                this.session.on('sessionConnected', this.publish);
             }

            if (this.consultation.anonym && !this.user.doctor) {
                this.switchVideo(false);
            }

            if (this.conferenceSetup) {
                this.switchVideo(this.conferenceSetup.isVideo);

                this.switchMic(this.conferenceSetup.isMic);
            }

            navigator.permissions.query({name: 'microphone'})
                .then((permissionStatus) => {
                    permissionStatus.onchange = () => {
                        return window.location.reload();
                    }
                }).catch(() => {
                    setInterval(() => {
                        this.checkMedia();
                    }, 1000);
            });

        },
        methods: {
            ...mapMutations('conference', [
                'setPublisher',
                'setMediaAccess',
                'switchVideo',
                'switchMic'
            ]),
            ...mapActions('conference', [
                'publish'
            ]),
            checkMedia() {
                OT.getUserMedia().then(() => {
                    if (!this.mediaAccess && this.session && this.session.isConnected()) {
                        return window.location.reload();
                    }
                }).catch(() => {
                    if (this.mediaAccess && this.session && this.session.isConnected()) {
                       return window.location.reload();
                    }
                });
            }
        }
    };
</script>
